import React from 'react';
import { getFormattedPrice } from '@/utils/price';
import classNames from 'classnames';
import Span from '@/shared/Span';

export interface INCEMI {
  eligible: boolean;
  ncemi: number;
  emiTenure: number;
}

interface NCEMIProps {
  data: INCEMI | null;
  className?: string;
}

const NCEMI = ({ data, className }: NCEMIProps) => {
  const { eligible, ncemi: ncemiAmount } = data ?? {};
  if (!eligible) return null;

  return (
    <Span
      className={classNames(
        'text-body-sm  inline-blocklg:text-body-base text-neutral-100',
        className,
      )}
    >{`No-cost EMI from ${getFormattedPrice(ncemiAmount)}/mo`}</Span>
  );
};

export default NCEMI;
